import GetLinkedCardsAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_nolpay/listCards/getLinkedCards.mdx";
import * as React from 'react';
export default {
  GetLinkedCardsAndroid,
  React
};